<template>
  <div ref="telegram"></div>
</template>

<script>
export default {
  mounted() {
    // create script with given params
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://telegram.org/js/telegram-widget.js?15'
    script.setAttribute('data-size', 'medium')
    script.setAttribute('data-telegram-login', 'neoputinomicsbot')
    script.setAttribute('data-request-access', 'write')
    window.onTelegramAuth = this.onTelegramAuth
    script.setAttribute('data-onauth', 'window.onTelegramAuth(user)')
    this.$refs.telegram.appendChild(script)
  },
  methods: {
    onTelegramAuth(user) {
      this.$emit('auth', user)
    },
  },
}
</script>

<style></style>
